import React, { useState } from 'react';
import { Mail } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL;

export const NewsletterSubscribe = () => {
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const res = await fetch(`${API}/api/newsletter/subscribe`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ full_name: fullName, email })
      });
      const data = await res.json();
      if (res.ok && data.success) {
        toast.success(data.message);
        setDone(true);
      } else {
        toast.error(data.detail || 'Subscription failed. Please try again.');
      }
    } catch {
      toast.error('Subscription failed. Please check your connection and try again.');
    }
    setSubmitting(false);
  };

  return (
    <div className="bg-[#0a1628] rounded-2xl p-8 sm:p-10 text-center" data-testid="newsletter-subscribe-box">
      <Mail className="w-8 h-8 text-amber-400 mx-auto mb-3" aria-hidden="true" />
      <h2 className="text-2xl font-bold text-white mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>
        Subscribe to Our Monthly Newsletter
      </h2>
      <p className="text-slate-300 text-sm max-w-lg mx-auto mb-6">
        Get The DC Early Learning Exchange in your inbox — policy updates, opportunities, resources, and program
        highlights from across DC&#39;s early childhood field.
      </p>
      {done ? (
        <p className="text-teal-300 font-semibold" data-testid="newsletter-subscribe-success">
          You&#39;re subscribed! Watch your inbox for the next edition.
        </p>
      ) : (
        <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 max-w-xl mx-auto">
          <label htmlFor="nl_sub_name" className="sr-only">Your name (optional)</label>
          <Input
            id="nl_sub_name"
            placeholder="Your name (optional)"
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
            className="bg-white/95 border-0"
            data-testid="newsletter-subscribe-name"
          />
          <label htmlFor="nl_sub_email" className="sr-only">Email address</label>
          <Input
            id="nl_sub_email"
            type="email"
            required
            placeholder="Email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="bg-white/95 border-0"
            data-testid="newsletter-subscribe-email"
          />
          <Button type="submit" disabled={submitting} className="bg-amber-500 hover:bg-amber-600 text-[#0a1628] font-bold shrink-0" data-testid="newsletter-subscribe-submit">
            {submitting ? 'Subscribing…' : 'Subscribe'}
          </Button>
        </form>
      )}
    </div>
  );
};

export default NewsletterSubscribe;
